import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { ThemeProvider } from './contexts/ThemeContext'
import '@fontsource/work-sans/300.css'
import '@fontsource/work-sans/400.css'
import '@fontsource/work-sans/500.css'
import '@fontsource/work-sans/600.css'
import '@fontsource/work-sans/700.css'
import 'material-icons/iconfont/material-icons.css'
import './index.css'
import { isEmbedded } from './lib/embed'
import { initEmbedBridge } from './lib/embedBridge'
import { isNotFound } from './api/http'

// Inside a partner iframe: apply embed CSS now, then load the runtime policy and request a
// session. AuthGuard shows "Connecting…" until the handshake lands.
if (isEmbedded()) void initEmbedBridge()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      // A 404 won't fix itself — retry other failures once, never not-found.
      retry: (failureCount, error) => !isNotFound(error) && failureCount < 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
)
